const CheckoutUtilities = {
  toggleVisible(element) {
    if(element.style.display == 'block') {
      element.style.display = 'none';
    } else {
      element.style.display = 'block';
    }
  },
};

export default CheckoutUtilities;
